import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ProductService} from '../../../resources/services/product.service';
import {ValidateService} from '../../../resources/modules/validate/validate.service';
import {ToastrService} from 'ngx-toastr';
import {FormService} from '../../../resources/services/form.service';
import {MessageService} from '../../../resources/services/message.service';
import {FormEntityExtension} from '../../../resources/extensions/form-entity-extension/form-entity.extension';
import {FormEntityExtensionService} from "../../../resources/extensions/form-entity-extension/form-entity-extension.service";

@Component({
  selector: 'store-group-form',
  templateUrl: './store-group-form.component.html',
})
export class StoreGroupFormComponent extends FormEntityExtension implements OnInit {


  constructor(protected formEntityExtensionService: FormEntityExtensionService) {
    super(formEntityExtensionService);
  }


  ngOnInit(): void {
    this.initForm(
      new FormBuilder().group({
        name: ['', Validators.required],
        active: [false],
        stores: [],
      })
    );
  }

}
